import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {MenuComponent} from '../assets/ts/components'

const PromoLayout = () => {
  const location = useLocation()

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root overflow-hidden'>
        {' '}
        <HeaderWrapper isPromo={true} />
        <div className='d-flex flex-row h-100'>
          <AsideDefault />
          <Outlet />
        </div>
      </div>
      <ScrollTop />
    </PageDataProvider>
  )
}

export {PromoLayout}
